var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import deleteIcon from '../../../assets/feather/trash-2-red.svg';
import { useForceUpdate } from "../../../lib/misc.functions";
import _ from "lodash";
import { Storage } from "../../../lib/localstorege.service";
import Trash from "../../../assets/feather/trash-2.svg";
import iconAlert from "../../../assets/feather/alert-circle.svg";
import { ApiService } from "../../../lib/http.service";
import { env } from "../../../definitions/global.vars";
import { location, member } from "../../../store/login.store";
import { Location } from "../../../models/user.model";
import { useNavigate } from "react-router";
import { modalServiceSubject } from "../../../components/modal/modal";
import Check from "../../../assets/feather/check.svg";
import AlertCircle from "../../../assets/feather/alert-circle.svg";
var api = new ApiService();
var LotterySlip = function (props) {
    var _a = useState(false), usePointBalance = _a[0], setUsePointBalance = _a[1];
    var navigate = useNavigate();
    var removeFromLotterySlip = props.removeFromLotterySlip;
    var clearLotterySlip = props.clearLotterySlip;
    var slipItems = props.slipItems;
    var forceUpdate = useForceUpdate();
    var multiplyChoices = _.range(1, 101);
    multiplyChoices.push.apply(multiplyChoices, _.range(200, 1001, 50));
    var setItemAmount = function (item, value) {
        item.amount = value;
        Storage.set('lotterySlip', slipItems);
        forceUpdate();
    };
    var totalQuantity = slipItems.reduce(function (accumulator, object) {
        return accumulator + object.amount;
    }, 0);
    var totalAmount = slipItems.reduce(function (accumulator, object) {
        return accumulator + (Number(object.amount) * Number(object.lotteryObject.ticketAmount));
    }, 0);
    var onLocation = function () {
        var object = new Location();
        object.path = "back";
        Object.assign(location, object);
        navigate('/giris-yap');
    };
    var validationSubmit = function () {
        if (!member || !member.id) {
            modalServiceSubject.next({
                title: 'Lütfen Giriş Yapınız',
                content: 'Eşya piyangosu bileti alabilmek için lütfen önce üye girişi yapınız.',
                confirm: {
                    cancel: { label: 'Tamam' }
                },
                timeout: 0,
                width: 370,
            });
            return false;
        }
        var LotterySlipTotal = 0;
        for (var _i = 0, slipItems_1 = slipItems; _i < slipItems_1.length; _i++) {
            var item = slipItems_1[_i];
            console.log(item.amount, Number(item.lotteryObject.ticketAmount));
            LotterySlipTotal += item.amount * Number(item.lotteryObject.ticketAmount);
        }
        console.log(LotterySlipTotal);
        if ((usePointBalance === true && member.getAvailableBalance() < LotterySlipTotal) ||
            (usePointBalance === false && member.debit_balance < LotterySlipTotal)) {
            // @ts-ignore
            document.getElementById('loadingPageAnimation').style.display = 'none';
            var memberBalance = usePointBalance ? member.getAvailableBalance().toFixed(2) : Number(member.debit_balance).toFixed(2);
            modalServiceSubject.next({
                title: 'Bakiye Yetersiz',
                content: "Sat\u0131n almak istedi\u011Finiz e\u015Fya piyangolar\u0131 bilet fiyatlar\u0131 toplam\u0131 <b>".concat(LotterySlipTotal.toFixed(2), "\u20BA</b> olup hesab\u0131n\u0131zda <b>").concat(memberBalance, "\u20BA</b> bakiye bulunmaktad\u0131r."),
                confirm: {
                    cancel: { label: 'Tamam', action: function () {
                            // @ts-ignore
                            document.getElementById('loadingPageAnimation').style.display = 'none';
                        } }
                },
                width: 370,
                timeout: 0,
                onClose: function () {
                    // @ts-ignore
                    document.getElementById('loadingPageAnimation').style.display = 'none';
                }
            });
            return false;
        }
        return true;
    };
    var buyTicket = function () {
        // @ts-ignore
        document.getElementById('loadingPageAnimation').style.display = 'block';
        var results = [];
        if (validationSubmit()) {
            var btnElement_1 = document.getElementById('id_btnBuyTickets');
            if (btnElement_1) {
                btnElement_1.disabled = true;
            }
            var payload = {
                unit: usePointBalance ? 2 : 0,
                ticket: null,
                token: Storage.get('token'),
            };
            var ticketObjects_1 = [];
            for (var _i = 0, slipItems_2 = slipItems; _i < slipItems_2.length; _i++) {
                var item = slipItems_2[_i];
                ticketObjects_1.push({
                    draw_no: item.somosDrawID,
                    multiply: item.amount,
                });
            }
            payload.ticket = JSON.stringify(ticketObjects_1);
            var successCount_1 = 0;
            api.start("post", "".concat(env.core_api, "/order/api/esya-piyangosu/kupon-olustur/"), payload, true, 60000)
                .then(function (res) {
                console.log(res);
                var table = '<table class="table table-bordered"><tr><th class="text-left">Çekiliş Adı</th><th class="text-center">Başarılı alınan bilet</th>' + (res.status === false ? '<th class="text-center">Hatalı bilet</th>' : '') + '</tr>';
                if (ticketObjects_1.length === 1) {
                    var clsItem = res.status ? 'row-success' : 'row-fail';
                    table += '<tr class="' + clsItem + '"><td class="text-left" style="text-transform: capitalize;">' + slipItems[0].lotteryObject.title.toLowerCase() + '</td><td class="text-center">' + res.data.success_count + ' adet</td>' + (res.status === false ? '<td class="text-center">' + res.data.error_count + ' adet</td>' : '') + '</tr>';
                    table += '</table>';
                    successCount_1 += Number(res.data.success_count);
                }
                else {
                    for (var _i = 0, slipItems_3 = slipItems; _i < slipItems_3.length; _i++) {
                        var item = slipItems_3[_i];
                        var clsItem = res.data[item.somosDrawID].status ? 'row-success' : 'row-fail';
                        table += '<tr class="' + clsItem + '"><td class="text-left" style="text-transform: capitalize;">' + item.lotteryObject.title.toLowerCase() + '</td><td class="text-center">' + res.data[item.somosDrawID].data.success_count + ' adet</td>' + (res.data[item.somosDrawID].status === false ? '<td class="text-center">' + res.data[item.somosDrawID].data.error_count + ' adet</td>' : '') + '</tr>';
                        successCount_1 += Number(res.data[item.somosDrawID].data.success_count);
                    }
                    table += '</table>';
                }
                // @ts-ignore
                document.getElementById('loadingPageAnimation').style.display = 'none';
                var displayDescription = '';
                if (successCount_1 > 0) {
                    displayDescription = "<br />Sat\u0131n alma i\u015Fleminize ait \u00F6zet a\u015Fa\u011F\u0131daki gibidir.<br />\n                Sat\u0131n ald\u0131\u011F\u0131n\u0131z biletlerin bilgisine <b>hesab\u0131m > E\u015Fya piyangosu</b> sayfas\u0131ndan ula\u015Fabilirsiniz. Bol \u015Eans dileriz.";
                }
                else {
                    displayDescription = "\u0130\u015Flem Ba\u015Far\u0131s\u0131z!<br />\n                <span>".concat(res.message, "</span>");
                }
                modalServiceSubject.next({
                    title: 'Piyango Satışı',
                    content: "<p class=\"text-center mt-3 mb-3\">\n                <img src=\"".concat(Check, "\" width=\"48\"  class=\"invert-color\" /><br />\n                \n            \n                ").concat(displayDescription, "\n                \n                ").concat(table, "\n                \n                </p>\n                <p class=\"text-center mt-3 mb-3\">\n                <b>\u00D6nemli!</b> \u00D6d\u00FCl kazanman\u0131z durumunda, ikramiyenizin teslimi i\u00E7in ilk 15 g\u00FCn i\u00E7erisinde talihli ba\u015Fvuru \n                i\u015Flemlerinizi tamamlayabilmeniz ve size yard\u0131mc\u0131 olabilmemiz i\u00E7in cep telefonu numaran\u0131z\u0131n g\u00FCncel \n                olmas\u0131 gerekir. \n                </p>"),
                    confirm: {
                        cancel: { label: 'Tamam', action: function () { clearLotterySlip(); } }
                    },
                    onClose: function () { clearLotterySlip(); },
                    timeout: 0
                });
                if (btnElement_1) {
                    btnElement_1.disabled = false;
                }
            })
                .catch(function (e) {
                console.log(e);
                modalServiceSubject.next({
                    title: 'Beklenmedi bir durum',
                    content: "<p class=\"text-center mt-3 mb-3\">\n                <img src=\"".concat(AlertCircle, "\" width=\"48\"  class=\"invert-color\" /><br />\n                 Bu durum bilet sat\u0131\u015F\u0131n\u0131z\u0131n oldu\u011Fu ya da olmad\u0131\u011F\u0131 anlam\u0131na gelmez.\n                <br /> L\u00FCtfen biletlerinizin durumunu kontrol edin!\n                </p>\n                <p class=\"text-center mt-3 mb-3\">\n                  <b>\u00D6nemli!</b> \u00D6d\u00FCl kazanman\u0131z durumunda, ikramiyenizin teslimi i\u00E7in, ilk 15 g\u00FCn i\u00E7erisinde talihli ba\u015Fvuru \n                  i\u015Flemlerinizi tamamlayabilmeniz ve size yard\u0131mc\u0131 olabilmemiz i\u00E7in cep telefonu numaran\u0131z\u0131n g\u00FCncel \n                  olmas\u0131 gerekir. \n                </p>\n                "),
                    confirm: {
                        cancel: { label: 'Tamam', action: function () {
                                // @ts-ignore
                                document.getElementById('loadingPageAnimation').style.display = 'none';
                                navigate('/hesabim/esya-piyangosu/');
                            } }
                    },
                    onClose: function () {
                        // @ts-ignore
                        document.getElementById('loadingPageAnimation').style.display = 'none';
                        navigate('/hesabim/esya-piyangosu/');
                    },
                    timeout: 0
                });
                if (btnElement_1) {
                    btnElement_1.disabled = false;
                }
            });
        }
    };
    return (_jsxs("div", __assign({ className: "hidden-sm card float-right", style: { width: 355 } }, { children: [_jsx("div", __assign({ className: "card-title pt-3 px-3" }, { children: _jsx("h4", { children: "Biletlerim" }, void 0) }), void 0), _jsx("div", __assign({ className: "card-body pt-0 pb-0 px-3", style: { borderBottom: '1px solid var(--color-bg-medium)' } }, { children: slipItems && slipItems.length > 0 ? (slipItems.map(function (item, key) {
                    return (_jsx("div", __assign({ className: 'lottery-item' }, { children: _jsxs("div", { children: [_jsx("div", __assign({ className: "title w-100 p-1" }, { children: item.lotteryObject.title.toLowerCase() }), void 0), _jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", __assign({ className: "w-50 p-0" }, { children: _jsxs("div", __assign({ className: "number-input-group" }, { children: [_jsx("input", { className: "select lottery-input", style: {
                                                            color: 'var(--color-text-dark)',
                                                            padding: '0px 5px',
                                                            margin: '3px 2px',
                                                            border: 0,
                                                            background: 'var(--color-bg-light)',
                                                            right: 37,
                                                            width: 'calc(100% - 40px)',
                                                            zIndex: 1,
                                                            position: 'absolute'
                                                        }, type: "number", pattern: "^[0-9]+$", min: "1", max: "1000", step: "1", value: item.amount, onChange: function (e) { return setItemAmount(item, Number(e.target.value)); } }, void 0), _jsx("select", __assign({ className: "select", value: item.amount, onChange: function (e) { return setItemAmount(item, Number(e.target.value)); } }, { children: multiplyChoices.map(function (el, key) {
                                                            return _jsx("option", __assign({ value: el }, { children: el }), key);
                                                        }) }), void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: "w-50 px-1 py-2 text-right" }, { children: [(Number(item.lotteryObject.ticketAmount) * Number(item.amount)).toFixed(2), "\u20BA"] }), void 0), _jsx("div", __assign({ className: "px-1 py-2", onClick: function () { return removeFromLotterySlip(item); } }, { children: _jsx("img", { src: deleteIcon, style: { width: 16 }, alt: "" }, void 0) }), void 0)] }), void 0)] }, void 0) }), 'slipItemss_' + key));
                })) : _jsxs("div", __assign({ className: "p-5 text-center" }, { children: [_jsx("p", __assign({ className: "p-3" }, { children: _jsx("img", { src: iconAlert, className: "invert-color", width: 64 }, void 0) }), void 0), "Sepetinizde bilet bulunmamaktad\u0131r."] }), void 0) }), void 0), _jsxs("div", __assign({ className: "card-title p-3" }, { children: [_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", __assign({ className: "w-100" }, { children: "Bilet adedi" }), void 0), _jsxs("div", __assign({ className: "w-75 fw-bold text-right" }, { children: [totalQuantity, " Adet"] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", __assign({ className: "w-100 " }, { children: "Toplam tutar" }), void 0), _jsxs("div", __assign({ className: "w-75 fw-bold text-right" }, { children: [totalAmount.toFixed(2), " \u20BA"] }), void 0)] }), void 0), _jsx("div", __assign({ className: "row group mt-2" }, { children: _jsxs("div", __assign({ className: "col-12 d-flex" }, { children: [_jsx("div", __assign({ className: "fw-bold mr-2" }, { children: "Puan Kullan: " }), void 0), _jsxs("label", __assign({ className: "m-0" }, { children: [" ", _jsx("input", { type: "checkbox", checked: usePointBalance, onChange: function () { setUsePointBalance(!usePointBalance); } }, void 0), "  ", member && member.point_balance ? (member.point_balance / 100).toFixed(2) + '₺' : '0.00₺'] }), void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: "row m-0 ml-n1 mr-n1" }, { children: [_jsx("div", __assign({ className: "w-25 p-1" }, { children: _jsx("button", __assign({ className: "btn btn-warning w-100 m-0", onClick: function () { return clearLotterySlip(); } }, { children: _jsx("img", { src: Trash, width: "16" }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "w-75 p-1" }, { children: member.id ? _jsx(_Fragment, { children: _jsx("button", __assign({ id: "id_btnBuyTickets", disabled: slipItems.length === 0, onClick: function () { buyTicket(); }, className: "btn w-100  m-0 btn-primary" }, { children: "SATIN AL" }), void 0) }, void 0) : _jsx(_Fragment, { children: _jsx("button", __assign({ disabled: slipItems.length === 0, onClick: function () { return onLocation(); }, className: "btn w-100  m-0 btn-primary" }, { children: "SATIN AL" }), void 0) }, void 0) }), void 0)] }), void 0)] }), void 0)] }), void 0));
};
export default LotterySlip;
